function Icon() {
  return (
    <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='60' height='60' rx='8' fill='#E6F0FF' />
      <path
        opacity='0.4'
        d='M39 24.0004V30.3229C39 30.5629 38.8093 30.7489 38.5693 30.7624C34.2223 30.9874 30.75 34.601 30.75 39.002C30.75 39.8435 30.8715 40.6474 31.1085 41.4064C31.2 41.7019 30.9975 42.002 30.687 42.002H21C18 42.002 16.5 40.502 16.5 37.502V19.502C16.5 16.502 18 15.002 21 15.002H30V19.502C30 21.9875 32.0145 24.002 34.5 24.002H39V24.0004Z'
        fill='#2A64F6'
      />
      <path d='M34.5 24H39L30 15V19.5C30 22.5 31.5 24 34.5 24Z' fill='#2A64F6' />
      <path
        d='M33 29.625H22.5C21.879 29.625 21.375 29.121 21.375 28.5C21.375 27.879 21.879 27.375 22.5 27.375H33C33.621 27.375 34.125 27.879 34.125 28.5C34.125 29.121 33.621 29.625 33 29.625ZM29.625 34.5C29.625 33.879 29.121 33.375 28.5 33.375H22.5C21.879 33.375 21.375 33.879 21.375 34.5C21.375 35.121 21.879 35.625 22.5 35.625H28.5C29.121 35.625 29.625 35.121 29.625 34.5Z'
        fill='#2A64F6'
      />
      <path
        d='M39 33C35.6865 33 33 35.6865 33 39C33 42.3135 35.6865 45 39 45C42.3135 45 45 42.3135 45 39C45 35.6865 42.3135 33 39 33ZM41.406 38.28L38.9055 40.7805C38.7645 40.9215 38.574 40.9995 38.3745 40.9995C38.175 40.9995 37.9845 40.92 37.8435 40.7805L36.594 39.531C36.3015 39.2385 36.3015 38.763 36.594 38.4705C36.8865 38.178 37.362 38.178 37.6545 38.4705L38.373 39.1905L40.3425 37.221C40.635 36.9285 41.1106 36.9285 41.4031 37.221C41.6956 37.5135 41.6985 37.9875 41.406 38.28Z'
        fill='#2A64F6'
      />
    </svg>
  );
}

export default Icon;
